var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('competition-detail-link',{attrs:{"detailLayout":_vm.detailLayout,"competitionData":_vm.competitionData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }